import type { CalendarEntryType, Tagtyp } from "@/types"

/** Anzeige-Konfiguration der 6 Tagtypen (feature_betriebskalender.md) */
export const DAY_TYPE_META: Record<Tagtyp, { label: string; cellClass: string; dotClass: string }> =
  {
    ARBEITSTAG: {
      label: "Arbeitstag",
      cellClass: "bg-background text-foreground hover:bg-accent",
      dotClass: "bg-background border",
    },
    WOCHENENDE: {
      label: "Wochenende",
      cellClass: "bg-muted text-muted-foreground hover:bg-muted/70",
      dotClass: "bg-muted border",
    },
    FEIERTAG: {
      label: "Feiertag",
      cellClass: "bg-red-100 text-red-800 hover:bg-red-200 dark:bg-red-950 dark:text-red-300",
      dotClass: "bg-red-200 border border-red-400",
    },
    BETRIEBSURLAUB: {
      label: "Betriebsurlaub",
      cellClass: "bg-blue-100 text-blue-800 hover:bg-blue-200 dark:bg-blue-950 dark:text-blue-300",
      dotClass: "bg-blue-200 border border-blue-400",
    },
    SONDERTAG: {
      label: "Sondertag",
      cellClass:
        "bg-purple-100 text-purple-800 hover:bg-purple-200 dark:bg-purple-950 dark:text-purple-300",
      dotClass: "bg-purple-200 border border-purple-400",
    },
    HALBER_ARBEITSTAG: {
      label: "Halber Arbeitstag",
      cellClass:
        "bg-orange-100 text-orange-800 hover:bg-orange-200 dark:bg-orange-950 dark:text-orange-300",
      dotClass: "bg-orange-200 border border-orange-400",
    },
  }

/**
 * Dezente Hintergrund-Toenung fuer Matrix-Zellen ohne Abwesenheit
 * (Monatskalender AbsencesPage/TeamOverviewTab) — Farbfamilien wie cellClass.
 */
export const DAY_TYPE_TINT: Record<Tagtyp, string> = {
  ARBEITSTAG: "bg-muted/25",
  WOCHENENDE: "bg-muted/60",
  FEIERTAG: "bg-red-100 dark:bg-red-950/60",
  BETRIEBSURLAUB: "bg-blue-100 dark:bg-blue-950/60",
  SONDERTAG: "bg-purple-100 dark:bg-purple-950/60",
  HALBER_ARBEITSTAG: "bg-orange-100 dark:bg-orange-950/60",
}

export const DAY_TYPE_ORDER: Tagtyp[] = [
  "ARBEITSTAG",
  "WOCHENENDE",
  "FEIERTAG",
  "BETRIEBSURLAUB",
  "SONDERTAG",
  "HALBER_ARBEITSTAG",
]

export const ENTRY_TYPE_LABEL: Record<CalendarEntryType, string> = {
  BETRIEBSURLAUB: "Betriebsurlaub",
  HINWEIS: "Hinweis",
  OVERRIDE: "Tagtyp-Override",
}

export const MONTH_NAMES = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
]

export const WEEKDAYS_SHORT = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]

/** Montag-basierter Wochentag-Index (0=Mo … 6=So) fuer "YYYY-MM-DD" */
export function weekdayIndex(isoDate: string): number {
  const [y, m, d] = isoDate.split("-").map(Number)
  return (new Date(y, m - 1, d).getDay() + 6) % 7
}

/** Heutiges Datum als lokales "YYYY-MM-DD" (kein toISOString — Timezone-Shift!) */
export function todayIso(): string {
  const now = new Date()
  const mm = String(now.getMonth() + 1).padStart(2, "0")
  const dd = String(now.getDate()).padStart(2, "0")
  return `${now.getFullYear()}-${mm}-${dd}`
}
